import {
    API_REQUEST,
    API_FAILURE,
    CREATE_SUCCESS,
    CREATE_FAILURE,
    GET_REASON_DATA_SUCCESS,
    GET_REASON_SUCCESS,
} from '../../../config/constants';

const initialState = {

};

export default function ReasonReducer(state = initialState, action) {
    switch (action.type) {
        case API_REQUEST:
            return {
                ...state,
                loading: true
            };
        case API_FAILURE:
            return {
                ...state,
                loading: false
            };
        case CREATE_SUCCESS: {
            return {
                ...state,
                loading: false,
                error: false
            };
        }
        case CREATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            };
        case GET_REASON_DATA_SUCCESS:
            let arr = []
            arr = action.payload && action.payload.filter((el, i) => {
                el.status = el.IsActive
                if (el.status === true) {
                    el.status = 'Active'
                } else if (el.status === false) {
                    el.status = 'In Active'
                }
                return true
            })

            return {
                ...state,
                loading: false,
                error: true,
                reasonDataList: arr,
            };
        case GET_REASON_SUCCESS:
            return {
                ...state,
                loading: false,
                error: true,
                reasonData: action.payload,
            };
        default:
            return state;
    }
}
